module.exports = __webpack_public_path__ + "static/mentor-harit-9324b903df21606b3dd8b7e9449d2c54.png";